import { render, staticRenderFns } from "./listTeam.vue?vue&type=template&id=5c6492ad"
import script from "./listTeam.vue?vue&type=script&lang=js"
export * from "./listTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports